











import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";

@Component
export default class HomeMiddleRanks extends AbpBase {
  //Warningcount:string;
  tableHeight = 330;
  ranklist = [];
  async getRank() {
    this.ranklist = await this.$store.dispatch({
      type: "thdata/getRank",
      data: 90,
    });
    //console.log(list);
  }
  created() {
    this.getRank();
  }

  mounted() {
    this.tableHeight = this.$refs.refwarningmain.offsetHeight - 40;
  }
  columnsrank = [
    {
      title: "排序",
      width: 60,
      align: "center",
      render: (h, params) => {
          let classname="disi";
          switch(params.index){
              case 0:classname="diyi";break;
              case 1:classname="dier";break;
              case 2:classname="disan";break;
          }
        return h("span", { class: classname }, params.index+1);
      },
    },
    {
      title: "库房",
      key: "wName",
    },
    {
      title: "楼层",
      key: "fName",
    },
    {
      title: "位置",
      key: "locationName",
    },
    {
      title: "温度",
      key: "temp",
    },
    {
      title: "湿度",
      key: "humi",
    },
    // {
    //   title: "预警次数",
    //   key: "Warningcount",
    // },
  ];
}
